import {
  TargetIdentifier,
  TargetView,
} from '@optools/services/operator-gateway/types/generated/graphql';

export const createTargetId = ({ id, type }: TargetIdentifier | TargetView) => `${id}-${type}`;
